import { compose } from 'recompose';
import { addProps, addIntlProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';

export const message = ({
  quantity,
  unit,
  units,
  submittedNotifcationStart,
  submittedNotifcationEnd,
}) => {
  const unitString = quantity > 1 ? units : unit;
  return `${submittedNotifcationStart} ${quantity} ${unitString} ${submittedNotifcationEnd}`;
};

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: [
      'unit',
      'units',
      'submittedNotifcationStart',
      'submittedNotifcationEnd',
    ],
  }),
  addProps({ message }),
);
